import catalogConfig from '../config/catalogConfig.mjs';
export default function (props) {
    return Object.fromEntries(Object.entries(props).filter(([key]) => catalogConfig.privacyFriendlyUserProperties.includes(key)));
}
